import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appHasPermission]',

  standalone: false,})
export class HasPermissionDirective implements OnInit {
  @Input() appHasPermission: string[];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {}

  ngOnInit(): void {
    // TODO: Intégrer le service de permissions pour vérifier les droits utilisateur
    // Exemple: this.permissionService.hasPermission(this.appHasPermission)
    const hasAccess = true; // Placeholder: à remplacer par la vraie vérification
    if (hasAccess) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
